import { TextField } from '@mui/material';

export default {
  size: "small",
  sx: {
    width: '100%',
    '& legend': { display: 'none' },
    '& fieldset': { top: 0 },
    '& .MuiFormLabelRoot ': 'none',
  },
  isOptionEqualToValue: (option, value) => option?.value === value?.value,
  getOptionKey: (value) => value?.value,
  renderInput: (params) => (
    <TextField
      {...params}
      type="search"
      label=""
      variant="outlined"
      inputProps={{
        ...params.inputProps,
        autoComplete: 'off',
      }}
    />
  )
}
